<nz-row>
  <nz-col nzSpan="24">
    <nz-list *ngIf="konstantes.result$ | async" nzSize="large" [nzLoading]="$loading | async">
      <nz-list-item *ngFor="let konstante of (konstantes.result$ | async).konstantes" (click)="select.emit(konstante)">
        <nz-list-item-meta [nzDescription]="ListDescription">
          <ng-template #ListDescription>
            <!--- << description    -->
            <!---    description >> -->
          </ng-template>
          <nz-list-item-meta-title>
            <a>
              <!--- << content    -->
              <strong>{{ konstante.art }}</strong>
              <nz-divider nzType="vertical"></nz-divider>
              {{ konstante.inhalt }}
              <!---    content >> -->
            </a>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <ul nz-list-item-actions>
          <nz-list-item-action>
            <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
          </nz-list-item-action>
        </ul>
      </nz-list-item>
    </nz-list>
  </nz-col>
</nz-row>
